import React from 'react';
import {Link, hashHistory} from 'react-router';
import { connect } from 'react-redux'
import '../login.css';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import FlatButton from 'material-ui/FlatButton';
import Header from '../Components/Header/HeaderUnauthorized';
import { resetPassword, identifyUser, sendPasswordChangeEmail, goToLogin }  from '../actions/authActions';
import { clearRegState } from '../actions/registrationActions'

const styleButton = {
    marginBottom:15
};

class ResetPasswordPage extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            Password: "",
            ConfirmPassword: "",
            code: "",
            Email: "",
            hasCode: false,
            reset: false
        };
    }

    componentDidMount(){
        var username = localStorage.getItem('username');
        if(username)
        {
            this.setState({Email: username});
        }
    }

    sendEmail = () => {
        localStorage.setItem('username', this.state.Email.trim());
        this.props.sendEmail(this.state.Email.trim())
    }

    resetPassword = () =>  {
        
        const creds = { 
            Email: this.state.Email.trim(),
            Code: this.state.code.trim(),
            Password: this.state.Password.trim(), 
            ConfirmPassword: this.state.ConfirmPassword.trim()
        };

        this.props.resetPassword(creds);
    }

    onIdentifyClick = (creds) => {
        this.props.onIdentifyClick(creds);
    }

    codeChange = (event, value) => {
        this.setState({ code: value});
    }

    passwordChange = (event, value) => {
        this.setState({ Password: value});
    }

    confirmPasswordChange = (event, value) => {
        this.setState({ ConfirmPassword: value});
    }

    emailChange = (event, value) => {
        this.setState({ Email: value});
    }

    enterCode = () => {
        this.setState({hasCode: true, Email:localStorage.getItem('username') });
    }
    
    cancelCode = () => {
        this.props.clearRegState();
        hashHistory.goBack();
    }
    
    goToLogin = () => {
        this.props.clearRegState();
        this.props.goToLogin();
    }

    render() {

    return (
        <div>
            <Header>
                <span className="white">Reset Password</span>
            </Header>
            
            <div className="container" >
                {(!this.props.isIdentified && !this.state.hasCode ) && (!this.props.passwordReset) &&  (
                    <div>
                        <div style={{textAlign:'center'}}>
                            <div className="container" >
                                <p className="white">Please enter the email address you used to create your account and we'll send a code to reset your password.</p>
                            </div>
                        </div>
                        <TextField hintText="Email Address" value={this.state.Email} onChange={this.emailChange} fullWidth={true} inputStyle={{color:"#fff"}} hintStyle={{color:"#fff"}} autoCapitalize="none" type="email" />
                        <br />
                        <br />
                        <RaisedButton label="Send Email" primary={true} style={styleButton} onClick={this.sendEmail} fullWidth={true} labelStyle={{fontSize: '20px'}}/>
                        <br />
                        <br />
                        <FlatButton label="I Have A Code" default={true} fullWidth={true} style={{border: '1px solid #FFF', color:"#fff", height:"40px"}}   labelStyle={{fontSize: '20px'}} onClick={this.enterCode}/>
                    </div>
                )}

                {(this.state.hasCode || this.props.isIdentified) && (!this.props.passwordReset) && (
                    <div>
                        <div style={{textAlign:'center'}}>
                            <br />
                            <div className="container" >
                                <p className="white">Enter the code below, and your new password. </p>
                            </div>
                        </div>
                        <TextField hintText="Email Address" value={this.state.Email} onChange={this.emailChange} fullWidth={true} inputStyle={{color:"#fff"}} hintStyle={{color:"#fff"}} autoCapitalize="none" type="email" />
                        <br />
                        <br />
                        <TextField hintText="Code from the email" value={this.state.code} onChange={this.codeChange} fullWidth={true} inputStyle={{color:"#fff"}} hintStyle={{color:"#fff"}} autoCapitalize="none" />
                        <br />
                        <br />
                        <TextField hintText="New Password"  value={this.state.Password} onChange={this.passwordChange}  type="password" fullWidth={true} inputStyle={{color:"#fff"}} hintStyle={{color:"#fff"}}/>
                        <br />
                        <br />
                        <TextField hintText="Re-enter New password"  value={this.state.ConfirmPassword} onChange={this.confirmPasswordChange}  type="password" fullWidth={true} inputStyle={{color:"#fff"}} hintStyle={{color:"#fff"}}/>
                        <br />
                        <br />
                        <RaisedButton label="RESET PASSWORD" primary={true} style={styleButton} onClick={this.resetPassword} fullWidth={true} labelStyle={{fontSize: '20px'}}/>
                        <br />
                        <br />
                        <FlatButton label="Cancel" default={true} fullWidth={true} style={{border: '1px solid #FFF', color:"#fff", height:"40px"}}   labelStyle={{fontSize: '20px'}} onClick={this.cancelCode}/>
                    </div>
                )}

                {(this.props.passwordReset) && (
                    <div>
                        <div style={{textAlign:'center'}}>
                            <br />
                            <br />
                            <br />
                            <div className="container" >
                                <h3 className="white">Your password has been reset! <br /></h3>
                            </div>
                        </div>
                        <RaisedButton label="Click Here to Login" primary={true} fullWidth={true} labelStyle={{fontSize: '20px'}} onClick={this.goToLogin} />
                    </div>
                )}
            </div>
        </div>
               
    );
  }

};

const mapDispatchToProps = (dispatch) => {
  return {
    resetPassword: (creds) => {
      dispatch(resetPassword(creds))
    },
    clearRegState: () => {
        dispatch(clearRegState())
      },
    sendEmail: (email) => {
      dispatch(sendPasswordChangeEmail(email))
    },
    goToLogin: () => {
      dispatch(goToLogin())
    }
  }
}


function mapStateToProps(state) {
    const { isFetching } = state.thisApp.environment;
    const { isIdentified, isRegistered, isVerified, passwordReset } = state.thisApp.register;
    const member = state.thisApp.auth.member;

  return {
    isIdentified,
    isRegistered,
    isVerified,
    isFetching,
    member,
    passwordReset
  }
}


export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ResetPasswordPage)





// WEBPACK FOOTER //
// ./src/Pages/ResetPassword.js